import { Injectable } from '@angular/core';
import autoTable, { RowInput } from 'jspdf-autotable';
import * as XLSX from 'xlsx-js-style';

@Injectable({
    providedIn: 'root',
})
export class ExportService {
    constructor() {}

    exportPdf(columnNames: string[], body: RowInput[], columnStyles: any, pdfTitle: string, pdfName: string) {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                import('jspdf-autotable').then(() => {
                    const doc = new jsPDF.default('landscape');
                    doc.text(pdfTitle, 8, 16);

                    autoTable(doc, {
                        margin: { top: 25, left: 8 },
                        head: [columnNames],
                        body: body,
                        columnStyles: columnStyles,
                        didDrawPage: data => {
                            data.settings.margin.top = 10;
                        },
                    });

                    doc.save(pdfName + '.pdf');
                });
            });
        });
    }

    exportExcel(rows: any[], columnStyles: any[], fileName: string): void {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet([...rows]);
        ws['!cols'] = columnStyles;
        XLSX.utils.book_append_sheet(wb, ws, fileName);
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    }
}
